<!-- <p-blockUI [blocked]="loading" [styleClass]="'block-ui'">
    <p-progressSpinner [style]="{width: '70px', height: '70px', display: 'block', 'margin-left':'auto', 'margin-right':'auto', 'margin-top':'50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration="1.5s"></p-progressSpinner>
</p-blockUI> -->

<div class="p-grid" style="margin: 15px;">

    <!-- <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col" style="text-align: left; font-family: 'Open Sans', 'Helvetica Neue', sans-serif;">
                <h3>MODE PUSH</h3>
                <p-inputSwitch [(ngModel)]="modePush" styleClass="mode" (onChange)="setMode()"></p-inputSwitch>
            </div>
        </div>
    </div> -->

    <p-panel *ngIf="showCQ" header="LISTE DES CQ EN ATTENTE" class="p-col-12" styleClass="cq" [style]="panelStyle()"  [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <div class="overflow-container">
            <p-table #dt [rowHover]="true" [loading]="cqLoading" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="cqCols" [value]="cqs" [lazy]="true" (onLazyLoad)="loadCqs($event)" [totalRecords]="cqsTotalRecords" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes">
                <ng-template pTemplate="caption">
                    
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of cqCols" [pSortableColumn]="col.field" [class]="(col.field === 'numPointAccueil') ? 'set-min' : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
    
                        <th>Contrôler</th>
                    </tr>
    
                    <tr>
                        <th *ngFor="let col of cqCols" [ngSwitch]="col.field">
                            <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'typePtl'" [style]="{'width':'100%'}" [options]="typeFilter" defaultLabel="Tous" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                        
                            <input *ngSwitchCase="'numPointAccueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'responsableCq'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'operateur'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'etat'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'tempsRestant'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
                            
                            <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'idComplexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                        </th>
    
                        <th></th>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="body" let-moderation let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
    
                            <ng-template [ngIf]="col.field === 'idComplexite'">
                                <span>
                                    {{ getComplexite(moderation[col.field]) }}
                                </span>
                            </ng-template>
                            <ng-template [ngIf]="col.field !== 'idComplexite'">
                                <span [class]="(col.field === 'etat' && moderation[col.field] !== '') ? ((moderation['idEtat'] === 3) ? 'customer-badge status-renewal' : 'customer-badge status-new' ) : ''">
                                    {{moderation[col.field]}}
                                </span>
                            </ng-template>
    
                        </td>
                        <td align="center"> <button pButton type="button" [disabled]="disabled" *ngIf="traitableCq(moderation['idEtat'])"  icon="pi pi-check"  style="width: 55px;" (click)="cqLink(moderation['idModeration'], moderation['idEtat'])"></button> </td>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-panel>

    <p-panel *ngIf="showModeration"  header="LISTE DES FICHES A MODERER" class="p-col-12" styleClass="moderation" [style]="panelStyle()" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <div class="overflow-container">
            <p-table #dt [rowHover]="true" [loading]="moderationLoading" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="moderationCols" [value]="moderations" [lazy]="true" (onLazyLoad)="loadModerations($event)" [totalRecords]="moderationsTotalRecords" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes">
                <ng-template pTemplate="caption">
                    
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of moderationCols" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ></p-sortIcon>
                        </th>
    
                        <th style="width: 100px; text-align: center;">Modérer</th>
                        <th *ngIf="canAffect()" style="width: 100px; text-align: center;">Affecter</th>
                        <th *ngIf="canVisualize()" style="width: 100px; text-align: center;">Pré-visualiser</th>
                    </tr>
    
                    <tr>
                        <th *ngFor="let col of moderationCols" [ngSwitch]="col.field">
                            <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'typePtl'" [style]="{'width':'100%'}" [options]="typeFilter" defaultLabel="Tous" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                            
                            <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'id_complexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
    
                            <input *ngSwitchCase="'numPointAccueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'idBonPlan'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">

                            <input *ngSwitchCase="'operateur'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'etat'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
    
                            <input *ngSwitchCase="'tempsRestant'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
                        
                            <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'idComplexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                        </th>
    
                        <th></th>
                        <th *ngIf="canAffect()"></th>
                        <th *ngIf="canVisualize()"></th>
                    </tr>
    
                </ng-template>
    
                <ng-template pTemplate="body" let-moderation let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
        
                            <ng-template [ngIf]="col.field === 'idComplexite'">
                                <span>
                                    {{ getComplexite(moderation[col.field]) }}
                                </span>
                            </ng-template>
    
                            <ng-template [ngIf]="col.field !== 'idComplexite'">
                                <span [class]="(col.field === 'etat' && moderation[col.field] !== '') ? ((moderation[col.field] === 'KO CQ' ) ? 'customer-badge status-unqualified' : ((moderation[col.field] === 'EN ATTENTE MODERATION') ? 'customer-badge status-negotiation' : 'customer-badge status-new') ) : ''">
                                    {{moderation[col.field]}}
                                </span>
                            </ng-template>
                            
                        </td>
                        <td align="center"> <button *ngIf="moderable(moderation['idEtat'])" [disabled]="disabled" pButton type="button"  icon="pi pi-id-card"  style="width: 55px;" (click)="moderationLink(moderation)" ></button> </td>
                        <td align="center" *ngIf="canAffect()"> <button  [disabled]="disabled" pButton type="button"  icon="pi pi-user-plus"  style="width: 55px;" (click)="showListePersonne(moderation)" ></button> </td>
                        <td align="center" *ngIf="canVisualize()"> <button  [disabled]="disabled" pButton type="button"  icon="pi pi-eye"  style="width: 55px;" (click)="previsualiser(moderation['idModeration'])" ></button> </td>
                        
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-panel>

</div>
